'use strict';

module.exports = {
	LANGUAGE: 'Programming',
	COMPUTATIONAL: 'Computational Thinking',
	MINECRAFT: 'Minecraft Specific',
	ROBLOX: 'Roblox Specific'
};
